import { render, staticRenderFns } from "./CreateProfileForm.vue?vue&type=template&id=3b1b5456&"
import script from "./CreateProfileForm.vue?vue&type=script&lang=js&"
export * from "./CreateProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports